import { gql } from '@apollo/client';

export const GET_LIST_AD = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetAdList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Ads {
        data {
          id
          status
          ad_set_id
          ad_set {
            ... on AdSet {
              id
              campaign_id
              team_id
              name
              start_date
              end_date
              budget
              created_at
              updated_at
              deleted_at
              campaign {
                id
                name
                start_date
                end_date
                budget
              }
            }
          }
          team_id
          team {
            ... on Team {
              id
              name
              partner
              limit
              start_date
              end_date
              created_at
              updated_at
              deleted_at
            }
          }
          name
          start_date
          end_date
          budget
          headline
          offer
          promo_code
          discount_type
          discount
          content
          product_name
          sku
          upc_user
          is_integrated
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;
export const GET_LIST_AD_DASHBOARD = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetAdList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Ads {
        data {
          id
          status
          name
          start_date
          end_date
          created_at
          updated_at
          deleted_at
          team_id
        }
      }
    }
  }
`;

export const GET_AD_BY_ID = gql`
  query GetByID($id: String!) {
    list: GetAdByID(id: $id) {
      id
      status
      team_id
      name
      start_date
      end_date
      budget
      headline
      offer
      content
      product_name
      sku
      upc_user
      created_at
      updated_at
      deleted_at
      promo_code
      discount_type
      discount
      ad_set {
        id
        name
        budget
        budget_remaining
        start_date
        end_date
        campaign {
          id
          name
          start_date
          end_date
          budget
        }
      }
    }
  }
`;

export const GET_BY_PROMO_CODE_AND_TEAM_ID = gql`
  query GetByPromoCodeAndTeamID($promo_code: String!, $team_id: String!) {
    unique: GetAdByPromoCodeAndTeamID(
      promo_code: $promo_code
      team_id: $team_id
    )
  }
`;
